const English = {
  Build: "Build",
  Hero_text: "your Resume in",
  record_time: "record time.",
  hero_sub_text: "Stand Out and Get Hired Quick with AI-Powered Assistance!",
  Generate_cv: "Generate Resume",
  Signup: "Sign up",
  Unlock: "Unlock AI-Powered Talent Discovery",
  Discover: "Discover Skilled Professionals Ready to Make an Impact",
  Did: "Did you know that 70% of Blue Collar Workers ",
  dont: "Don't Have Resumes ?",
  Did_subText:
    "Stand out from the competition by creating a professional resume today. Get started now and unlock new career opportunities!",
  Get_Started: "Get started",
  Coming_soon: "Coming soon!",
  Marching_tool: "AI Powered Job and talent Matching tool",
  Coming_soon_sub_text:
    "Bridge the gap between workers and businesses with our seamless platform. Discover flexible work options that fit your schedule. Join our network of talented individuals and unlock exciting opportunities.",
  Hire_Talent: "Hire talents too!",
  Select_resume:
    "Select your favorite design and create your professional resume effortlessly. Our platform makes it quick and convenient for you to showcase your skills and experiences effectively.",
  Generate: "Generate",
  coat_1:
    "Moil is a game-changer for the fast food industry! It helped me showcase my skills and land better-paying positions. Thanks to Moil, I've taken my career to the next level!",
  coat_2:
    "As a construction worker, Moil understands my challenges and connects me with clients who appreciate my hard work. It's the go-to platform for construction professionals",
  coat_3:
    "In the cleaning industry, Moil has given my skills the recognition they deserve. The jobs I've landed through Moil have been financially rewarding and helped me build a strong reputation. Give Moil a try!",
  Subscribe: "Subscribe and get exclusive deals & offers.",
  form_enter_your_mail: "Enter your email",
  Subscribe_btn: "Subscribe",
  Company: "Company",
  About: "About",
  Careers: "Careers",
  Logistic: "Logistics",
  Privacy_Policy: "Privacy & Policy",
  Contacts: "Contacts",
  Help_FAQ: "Help/FAQ",
  Press: "Press",
  Affilates: "Affilates",
  More: "More",
  Press_Centre: "Press Center",
  Our_Blog: "Cour Blog",
  Low_fare_tips: "Low fare tips",
  Copy_write: "Copyright, Trabook 2022. All rights reserved.",
  Terms_condition: "Terms & Conditions",
  Careers: "Careers",
  Translate: "Translate",
  Discover: "Discover",
  extract: "Extracting CV text, this can take a couple of minutes",

  Personal_info: "Personal Information",
  Education: "Education",
  Work_Experience: "Work Experience",
  Skills: "Skills",
  Vol_Exp: "Volunteer Experience",
  Award_Honor: "Awards and Honors",
  Ref: "References",
  Submit: "Submit",

  register_text:
    "Sign up now to unlock exclusive benefits and access to our platform. It's quick, easy, and free!",
  LoginPage: "*",
  left_text: "Join us, answer some questions and take the first step toward your dream career by creating a proile/resume.",
  Welcome_back: "Welcome back!",
  Enter_your_info: "Enter the information you entered while registering.",
  Email: "Email",
  Password: "Password",
  Confirm_pass: "Confirm Password",
  Remember_me: "Remember me",
  Forgot_pwd: "Forgot password",
  Acct_q: "Don't have an acoount?",
  Already_acct: "Already have an account?",
  sign_up: "sign up",
  Login: "Login",
  or: "or",
  sign_with_l: "sign in with Linkedin",
  sign_with_g: "sign in with Google",

  Dashboard_page: "*",
  welcome_text: "You are not alone,",
  welcome_sub_text:
    "Remember a great CV gives a a great impression, impress your recruiters today!",
  second_part_text:
    "Create a Professional Dashboard to enjoy the full benefits of Moil.",

  spanish_T: "Español",
  english_T: "English",
  Profile_page: "*",
  My_profile: "My Profile",
  About: "About",
  Skill: "Skill",
  Info: "Info",
  Location: "Location",
  Links: "Links",
  Edit: "Edit",

  Logout_comp_text: "*",
  Logout_text: "Are you sure you want to logout",
  Yes: "Yes",
  No: "No",

  continue_btn: "Continue",

  Warning_modal_text: "*",
  Warning_text:
    "In this step, select your favourite template",
  modal_ai:
    "Our AI tool is generating a standard experience description for you. Kindly wait a minute...",
  modal_AI:
    "Our AI tool is generating a standard professional summary for you. Kindly wait a minute...",

  Upload: "*",
  Upload_heading: "Upload CV/Resume",
  Upload_text:
    "Reducing your time for CV generation by uploading an existing Resume",
  Upload_btn_text: "Upload",
  skip_btn_text: "Skip this step",

  CV_template_text: "*",
  Back_to_dashboard: "Back to Dashboard",
  select_text: "Select Resume Template",

  Resume_form: "*",
  Submit: "Submit",
  Hey_there:
    "Hey there! We’re excited to help you create an awesome resume. Don’t worry about formal language - just tell us about your experience and skills in your own words. We’ll take care of the rest!",
  Resume_text: "Resume Text Capturing Form",
  your_name: "What is your full name ?",
  your_name_p: "first and last name",
  your_email: "What is your full email ?",
  your_email_p: "your email",
  your_address: "Your Address",
  your_address_p: "Address, city, state",
  your_phone_no: "What is your phone number ?",
  your_phone_no_p: "123 456 7890",
  your_job_title: "What is the job title you are applying for?",
  your_job_title_p: "Job title",
  your_linkedin: "Linkedin Profile",
  your_website: "Your website",
  back_to_template: "Back To Templates",
  next_btn: "Next",

  toast: "*",
  toast_job: "Please enter the experience job title",
  toast_des: "Breifly describe your daily activity",
  toast_exp: "Please provide a work experience",
  toast_skill: "please provide a skill",
  toast_lang: "please select a langage",
  toast_interest: "please provide an interest",
  t_lang_format: "language format is required",
  t_lang_select: "You can only select one language.",
  p_summary: "professional sumary is required",

  Education: "Education",
  your_school: "Where did you go to school",
  your_school_p: "Enter your School",
  your_degree: "What level of education do you have ?",
  n_school: "No School",
  h_school: "High school",
  c_school: "College",
  m_school: "Masters",
  p_sch: "PHD",
  s_sch: "some college",
  o_sch: "other",
  your_course: "What course did you study ?",
  your_course_p: "Enter Course",
  sch_start: "When did you start school ?",
  month_year: "Month Year",
  sch_end: "When did you finished school",
  Add_btn: "Add Education",
  back_btn: "Back",
  wrk_exp: "Work Experience",
  where_you_wrk: "Where have you worked",
  where_you_wrk_p: "Enter work place",
  wrk_role: "What was your job title or role",
  wrk_start: "When did you start and end this job",
  start_btn: "Start",
  End: "End",
  strt_btn_date: "Start Date",
  End_date: "End Date",
  description: "In your own word tell what you do on a day to day basis",
  click_text:
    "Click the button below to structure your experience with out AI tool",
  cap_genetate_text: "GENERATE",
  add_exp: "Add Experience",
  skill: "Skill",
  select_skill:
    "Select from the list of skills or type to add a new skill and end it with comma ',' ",
    select_skill_sm: "Select from the list of skills or type to add a new skill and end it with comma ',' and then click it on add it from the drop down list",
  sk_tech: "What are some technical or job-specific skills you have",
  sk_personal: "What are some personal skills you’re proud of ",
  volun_text: "Volunteer Experince",
  vol_org: "What’s the name of the organization ",
  vol_p: "enter organization",
  vol_start: "When did you join ",
  add_text: "Add",
  Award_Hon: "Award and Honors",
  awd_title: "What was the title of the award ?",
  awd_t_p: "Enter award name",
  awd_giver: "Who gave it to you and why ?",
  awd_time: "When did you receive it?",
  awd_add_text: "Add Award",
  Reference: "Reference",
  ref_who: "Who would you like to list as a reference?",
  ref_ans: "Enter name",
  ref_person: "How do you know this person?",
  ref_what: "What’s their job title and where do they work?",
  ref_email: "Reference Email",
  ref_phone: "Reference Phone number",
  spk_lang: "What languages do you speak?",
  lang: "language",
  spk_rate: "Langauage Speaking rate",
  add_lang_btn: "Add language",
  Interests: "Other professional interests",
  int_p: "Seperated by ,",
  res_lang: "What language do you want the resume to be?",
  res_lang_p: "What language do you want the resume to be",
  prof_sum: "How would you describe your professional summary?",
  prof_gen_text: "Generate professional summary by clicking the button below.",
  all_cv: "Download your resume and click this button",
  done: "done",
  long_press: "Long press the open button and click ",
  download: "download link",
  cv: "to download your CV",

  your_res: "Your Resume is ready for download!",
  refresh: "Refresh the page to view your resume.",
  cancel: "Cancel",
  preview: "Preiew",

  final_modal: "*",
  m_top_text: "Thanks for choosing ",
  m_btn: "Continue to view your resume.",

  Dashboard: "Dashboard",
  Profile: "Profile",
  My_resume: "My Resume",
  Logout: "Logout",
  Sub: "Subscribe Premium",

  text: "Click on the cylindrical shapes at the bottom to properly view your experience and edit them appropriately..",

  forget: "*",
  forget_pass: "Forgot Password",
  mail_send: "We would send your password reset link to provided email.",
  Enter_mail: "Enter your Email",
  p_email: "Please enter your email address",
  Back_to_login: "Back to Login",

  Reset_pass: "Reset Password",
  New_pass: "Enter a new password and make sure you don’t forget.",
  new_password: "New Password",
  confirm_pass: "Confirm New Password",
  Ensure: "Please ensure that your password and confirm password are correct.",
  reset: "Reset",

  // BigSam
  // /generateCV
  back_button: "Back",
  note_beta_version:
    "Please note that the Beta Version allows the creation of up to two pages of your CV.",
  select_resume: "Select Resume Template",

   final_modal: "*",
   m_top_text: "Thanks for choosing ",
   m_btn: "Preview your profile and resume.",
  //   form1
  resume_caph1: "Resume Text Capturing Form",
  heythere_form1:
    "Hey there! We’re excited t help you create an awesome resume. Don’t worry about formal language - just tell about your experience and skills in your own words.",
  also_used: "This will also be used for creating your profile!",
  tab_1: "Personal Information",
  whatsname: "What’s your first name?",
  firstName: "First Name here",
  lastname: "Last Name here",
  address_holder: "Address, city, state",
  email_here: "Email address here",


  whats_lastname: "What’s your last name?",
  whats_address: "What’s your address?",
  whats_email_address: "What’s your email address?",
  whats_phone_number: "What is your phone number?",
  whats_linkedin:
    "Do you have a LinkedIn profile or personal website? (Optional)",
  linkedin_profile_link: "LinkedIn Profile",
  whats_website: "Your Website",
  back_templates: "Back to Templates",
  save_n_continue: "Save and Continue",
  first_place: "First Name here",
  lastnaem_place: "Last Name here",

  //   form2
  fillform_tab2: "Fill this form to let employers know about your education.",
  usedfor_creating: "This will also be used for creating your profile!",
  education_tab2: "Education",
  where_school: "Where did you go to school?",
  education_level: "What level of education do you have?",
  degree_gotten: "What degree did you get?",
  start_studies: "When did you start your studies?",
  select_month_year: "Select the month and year accordingly.",
  finish_studies: "When did you finish your studies?",
  set_end_month: "Select the end month and year accordingly.",
  special_recogn:
    "Did you receive any special recognition or awards? (optional)",
  have_added: "You have added",
  previous_btn: "Previous",
  add_more: "Add More",
  view_less: "View less",
  view_more: "View more",
  level_place: "Select level",
  enter_degree_p: "Enter your degree here",
  award_here_place: "Enter award here",
  fm2_dates: "Month Year",

  //   form3
  work_experience: "Work Experience",
  where_work: "Where have you worked",
  what_job_title: "What was your job title or role?",
  when_start_end: "When did you start and end this job",
  select_start_end: "Select the start month and year accordingly.",
  in_own_words: "In your own words tell what you do on a day to day basis",
  generate_experience: "Generate Experience",
  workplace_place: "Type the name of your workplace here",
  title_place: "Enter your job title here",

  //   form4
  skills_licencing: "Skills & Licensing",
  soft_proud: "What are some soft skills you’re proud of?",
  certification_licence: "Do you have any certification/license? (Optional)",
  where_when_get: "Where and when did you get it?",
  licence_place: "Certification / license name",

  //   form5
  volunteer_experience: "Volunteer Experience",
  voluteer_org: "At what organization did you volunteer?",
  when_voluteer: "When did you volunteer?",
  ogarnization_place: "Enter organization here",
  month_place: "Month",

  //   form6
  complete_award:
    "Complete this page with any awards you have received in the past. If you have no awards, click on",
  skip_quotes: "'Skip this page'",
  at_the_bottom: "at the bottom of the page.",
  awards_honors: "Awards and Honors",
  title_award: "Title of the Award received",
  who_give_why: "Who gave it to you ?",
  when_recieve: "When did you receive it?",
  skipstage_noquote: "Skip this stage",
  award_place: "Award title",
  enter_place_name: "Enter name here",
  year_place: "Year",

   head: "In this step, select your favourite template.",
  //   form7
  refrence: "Reference",
  who_refrence: "Who would you like to list as a reference?",
  how_person: "How do you know this person?",
  who_them_be: "What’s their job title and where do they work?",
  their_phone: "What is their phone number?",
  their_email: "What is their email address?",
  fullname_place: "Enter their full name here",
  answer_here_place: "Answer here",
  phone_here_place: "Phone number here",

  //   form8
  lang_form8: "Language",
  first_lang: "What language do you speak ?",
  proficiency_level: "What is your proficiency level?",
  resume_lang: "What language do you want the resume to be?",
  proficiency_level_place: "Select your proficiency level",
  res_lang_place: "Resume laguage",
  lang_place: "Language",

  //   form9
  job_type: "Job Type",
  typejob_form9: "What type of job are you looking for?",
  let_employer_know:
    "Let employers know the type of job you want to be hired for. For example, plumbing, waitress, electrician.",
  update_job: "Update job title",
  years_experience: "How many years of experience do you have?",
  update_years: "Update year of experience",
  other_pro_interst: "Other professional interests?",
  update_pi: "Update professional interest",
  pro_summary: "In your own words, describe your professional summary?",
  describe_pro_sum:
    "Describe your professional summary and click on the ‘Generate Summary’ button so that our AI can help with a better summary.",
  do_you_want: "Do you want your job title to be displayed on your resume?",
  save_n_preview: "Save and Preview",
  years_experience_place: "Enter years of experience here",
  pro_exp_place: "Enter other professional interests",
  generate_sum: "Generate summary",
};


export default English;
